import http from "../components/services/utility";
import { apisPath } from "./path";

export const generateCaptcha = () => {
  const string = "0123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ";
  const len = string.length;
  let captcha = "";
  for (let i = 0; i < 6; i += 1) {
    captcha += string[Math.floor(Math.random() * len)];
  }
  return captcha;
};

export const calculateAge = (dob, year) => {
  // console.log(dob)
  let getFullYear = new Date(dob).getFullYear()

  if (!isNaN(new Date(dob).getTime())) {
    const now = new Date(year, 6, 1);   // 1 July year based calculation
    // console.log(now)
    const yearNow = now.getYear();
    const monthNow = now.getMonth();
    const dateNow = now.getDate();

    const yearDob = dob.getYear();
    const monthDob = dob.getMonth();
    const dateDob = dob.getDate();
    let monthAge = 0, dateAge = 1;


    const checkLeapYear = (getFullYear) => {
      if (((0 === getFullYear % 4) && (0 !== getFullYear % 100)) || (0 === getFullYear % 400)) {
        return true;
      }
      else {
        return false;
      }
    }

    let days = {
      '0': 31,
      '1': checkLeapYear(getFullYear) ? 29 : 28,   // On Internet Feb month calculate by default 30 days
      '2': 31,
      '3': 30,
      '4': 31,
      '5': 30,
      '6': 31,
      '7': 31,
      '8': 30,
      '9': 31,
      '10': 30,
      '11': 31
    }

    let yearAge = yearNow >= yearDob ? yearNow - yearDob : 0;
    if (monthNow >= monthDob)
      monthAge = monthNow - monthDob;
    else {
      yearAge--;
      monthAge = 12 + monthNow - monthDob;
    }

    if (dateNow >= dateDob)
      dateAge = dateNow - dateDob;
    else {
      monthAge--;
      dateAge = days[monthDob] + dateNow - dateDob;

      if (monthAge < 0) {
        monthAge = 11;
        yearAge--;
      }
    }

    return {
      year: yearAge,
      month: monthAge,
      day: dateAge ? dateAge : 1
    }
  }
  else {
    return ''
  }
}

export const getDate = (date, type = 'new') => {
  return http
    ?.post(apisPath?.front?.getAge, { dob: date, type: type })
    .then((res) => {
      const tempData = res?.data?.data;
      return {
        age: `${tempData?.year} years ${tempData?.month} months ${tempData?.day === 0 ? "1" : tempData?.day
          } days`,
        error: false,
      };
      // setIsLoading(false)
    })
    .catch((err) => {
      // setIsLoading(false)
      return {
        error: true,
        msg: err?.response?.data?.msg,
      };
    });
};

export const abledType = [
  // {
  //   short_code: "ID (Intellectual Disability)",
  //   name: "ID (Intellectual Disability)",
  // },
  {
    short_code: "LV/PB (Low Vision/Partially Blind)",
    name: "LV/PB (Low Vision/Partially Blind)",
  },
  {
    short_code: "HH/PD (Hard of Hearing/Partially Deaf)",
    name: "HH/PD (Hard of Hearing/Partially Deaf)",
  },
  {
    short_code: "D (Deaf)",
    name: "D (Deaf)",
  },
  // {
  //   short_code: "PB (Partially Blind)",
  //   name: "PB (Partially Blind)",
  // },
  // {
  //   short_code: "PD (Partially Deaf)",
  //   name: "PD (Partially Deaf)",
  // },
  // {
  //   short_code: "HH (Hard of Hearing)",
  //   name: "HH (Hard of Hearing)",
  // },
  {
    short_code: "OA (One Arm)",
    name: "OA (One Arm)",
  },
  {
    short_code: "OL (One Leg)",
    name: "OL (One Leg)",
  },
  // {
  //   short_code: "CP (Cerebral Palsy)",
  //   name: "CP (Cerebral Palsy)",
  // },
  {
    short_code: "LC (Leprosy Cured)",
    name: "LC (Leprosy Cured)",
  },
  {
    short_code: "DW (Dwarfism)",
    name: "DW (Dwarfism)",
  },
  {
    short_code: "AAV/AV (Acid Attack Victims/Acid Victims)",
    name: "AAV/AV (Acid Attack Victims/Acid Victims)",
  },
  // {
  //   short_code: "AAV (Acid Attack Victims)",
  //   name: "AAV (Acid Attack Victims)",
  // },
  // {
  //   short_code: "Th (Thalassaemia)",
  //   name: "Th (Thalassemia)",
  // },
  // {
  //   short_code: "Hp (Hemophilia)",
  //   name: "Hp (Hemophilia)",
  // },
  // {
  //   short_code: "MDy (Muscular Dystrophy)",
  //   name: "MDy (Muscular Dystrophy)",
  // },
  // {
  //   short_code: "ASD (Autism Spectrum Disorders)",
  //   name: "ASD (Autism Spectrum Disorders)",
  // },

  // {
  //   short_code: "MI (Mental Illness)",
  //   name: "MI (Mental Illness)",
  // },
];

export const currentDate = new Date();

export const minDate = (min) => new Date(currentDate.getFullYear() - min, 6, 1);

export const maxDate = (max) => new Date(currentDate.getFullYear() - max, 6, 1);

export const minAge = 60;
export const maxAge = 21;

export const oldMinAge = 62;
export const oldMaxAge = 23;


export const minDot = new Date("1977-01-01");
export const maxDot = currentDate;
export const minDod = new Date("1977-01-01");
export const maxDod = new Date(`2024-03-17`);
export const minDor = new Date("1977-01-01");
export const maxDor = currentDate;

export const dayBefore = (date) => new Date(new Date(date).getTime() - 86400000);

export const blockInvalidChar = (e) =>
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

export const blockAfterTwoDigit = (e) => {
  const temp = e.target.value.split(".");
  if (temp.length > 1) {
    if (temp[1].length > 2) {
      e.preventDefault();
    }
  }
};

export const appPrefix = 'ETE'

export const notEligibleMsg =
  "You are not eligible to apply, please read the advertisement";
export const notDomicile =
  `Domicile as Yes is Mandatory`;